<template>
    <div>已跳转乐居智能大屏页面，请在新页面查看</div>
  </template>
  <script>
  export default {
    data () {
      return {
  
      }
    },
    created () {
      this.tiaoZhuan()
    },
    methods: {
      tiaoZhuan () {
      //  window.open('https://gd-leju.cn/#/lejuListDp')
        window.open('https://leju.zw56.cn/#/lejuListDp')
      }
    }
  }
  </script>
  <style>
  
  </style>
  